import { FunctionComponent } from "react";

import {
    getLastStringFromUrl,
    getLastStringParamFromUrl,
    useHasuraSubscriptionWithCache,
    useHasuraSubscriptionWithFilter,
} from "src/helpers";

import {
    CHAPTER_QUERY,
    CHAPTERS_QUERY,
    CHAPTER_AGGREGATE_QUERY,
} from "../../graphql";

export const withHookForChapters = (Component: FunctionComponent) => {
    const WithComponent = (props) => {
        const { pagination, where } = props;
        const book_id = parseInt(getLastStringFromUrl());
        const queryDocumentResult = useHasuraSubscriptionWithCache(
            CHAPTERS_QUERY,
            {
                variables: {
                    ...pagination,
                    where,
                    parent_id: book_id,
                },
            },
        );
        const graphqlData = useHasuraSubscriptionWithFilter(
            queryDocumentResult,
            { queryName: "chapters", ...props },
        );
        const {
            loading,
            items,
            error,
            loadItemsData,
            fetchMore,
            refetch,
            subscribeToMore,
            updateQuery,
        } = graphqlData;

        if (error) throw new Error(error.message);
        return (
            <Component
                {...{
                    loading,
                    chapters: items,
                    subscribeToMore,
                    updateQuery,
                    loadChaptersData: loadItemsData,
                    refetchChapters: refetch,
                }}
                {...props}
            />
        );
    };
    return WithComponent;
};

export const withHookForAggregateChapter = (Component: FunctionComponent) => {
    const WithComponent = (props) => {
        const { where } = props;
        const book_id = parseInt(getLastStringFromUrl());

        const queryDocumentResult = useHasuraSubscriptionWithCache(
            CHAPTER_AGGREGATE_QUERY,
            {
                variables: { where, parent_id: book_id },
            },
        );
        const graphqlData = useHasuraSubscriptionWithFilter(
            queryDocumentResult,
            { queryName: "chapterAggregate", ...props },
        );
        const { loading, items, error, subscribeToMore, updateQuery } =
            graphqlData;

        if (error) throw new Error(error.message);
        return (
            <Component
                {...{
                    loading,
                    chapterAggregate: items,
                    subscribeToMore,
                    updateQuery,
                }}
                {...props}
            />
        );
    };
    return WithComponent;
};

export const withHookForChapter = (Component: FunctionComponent) => {
    const WithComponent = (props) => {
        const {} = props;
        const queryDocumentResult = useHasuraSubscriptionWithCache(
            CHAPTER_QUERY,
            {
                variables: {
                    id: getLastStringFromUrl(),
                },
            },
        );

        const { loading, error, data, subscribeToMore, updateQuery } =
            queryDocumentResult;
        if (error) throw new Error(error.message);
        return (
            <Component
                {...{
                    loadingChapter: loading,
                    chapter: data?.chapter,
                    subscribeToMore,
                    updateQuery,
                }}
                {...props}
            />
        );
    };
    return WithComponent;
};
